import { ArrowDownLeft, ArrowUpRight } from "lucide-react";

export const isInboundSms = (c) => c?.direction === "inbound" && c?.channel === "sms";

export const DirectionBadge = ({ comm, testId }) => {
    if (isInboundSms(comm)) {
        return (
            <span
                className="inline-flex items-center gap-1 rounded-full bg-emerald-100 text-emerald-800 ring-1 ring-emerald-200 px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wide whitespace-nowrap"
                data-testid={testId}
            >
                <ArrowDownLeft className="h-3 w-3" /> Inbound reply
            </span>
        );
    }
    const Icon = comm?.direction === "inbound" ? ArrowDownLeft : ArrowUpRight;
    return (
        <span className="inline-flex items-center gap-1 capitalize text-xs text-gray-600" data-testid={testId}>
            <Icon className="h-3 w-3" /> {comm?.direction || "outbound"}
        </span>
    );
};

export const CommBodyCell = ({ comm, testId }) => {
    const body = comm?.body || "";
    if (isInboundSms(comm)) {
        return (
            <div className="max-w-[320px]" data-testid={testId}>
                <div className="text-xs text-gray-900 whitespace-pre-wrap break-words bg-emerald-50 border-l-2 border-emerald-400 rounded-r px-2 py-1">
                    {body || "(empty message)"}
                </div>
                {comm.from_phone ? (
                    <div className="mt-1 text-[10px] font-mono text-gray-500">from {comm.from_phone}</div>
                ) : null}
            </div>
        );
    }
    return (
        <div className="text-xs text-muted-foreground truncate max-w-[260px]" title={body} data-testid={testId}>
            {body.slice(0, 200) || "—"}
        </div>
    );
};
